import React, { ReactElement } from "react";
import { IconSvgProps } from "./icon-svg.types";

export const IconSvg = ({
  children,
  ...svgAttrs
}: IconSvgProps): ReactElement => {
  const defaultStyle = {
    fill: "#121315",
    width: 24,
    height: 24,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      {...svgAttrs}
      style={{ ...defaultStyle, ...svgAttrs.style }}
    >
      {children}
    </svg>
  );
};
